module.exports = __webpack_public_path__ + "static/media/side-effects-burst.69406008.png";